// lib/session-context.tsx
"use client";

import { createContext, useContext, type ReactNode } from "react";
import type { AuthUser } from "@/lib/auth-server";
import { hasAdminRole } from "@/lib/auth-roles";

// Re-export so existing client consumers of `@/lib/session-context` that also
// import ADMIN_ROLE from here keep resolving. Source of truth: @/lib/auth-roles.
export { ADMIN_ROLE } from "@/lib/auth-roles";

interface SessionContextValue {
  user: AuthUser | null;
  isAdmin: boolean;
}

const SessionContext = createContext<SessionContextValue>({
  user: null,
  isAdmin: false,
});

export function SessionProvider({
  user,
  children,
}: {
  user: AuthUser | null;
  children: ReactNode;
}) {
  const value: SessionContextValue = {
    user,
    isAdmin: hasAdminRole(user?.role),
  };
  return <SessionContext.Provider value={value}>{children}</SessionContext.Provider>;
}

export function useSession(): SessionContextValue {
  return useContext(SessionContext);
}
